export function createReconnectRefetch(refetch: () => Promise<void>, onError: (error: unknown) => void): () => void {
  let running = false;
  let requested = false;
  const drain = async () => {
    running = true;
    try {
      do {
        requested = false;
        try {
          await refetch();
        } catch (error) {
          onError(error);
        }
      } while (requested);
    } finally {
      running = false;
    }
  };
  return () => {
    requested = true;
    if (!running) void drain();
  };
}
